module.exports = __webpack_public_path__ + "img/icon-padlock.8ef23df5.svg";